import { WrapComponent } from '../components/WrapComponent';
import { generateRenderingObject, generateWrapperComponents } from './wrappers.util';
import { WrapWithRouterReduxContainer } from '../components/wrappers/WrapWithRouterReduxContainer';
export const getClientWrappers = async (renderData, storeAndRouterHistory) => {
    const possibleWrappers = [];
    const { store, routerHistory } = storeAndRouterHistory || {};
    if (!!store && !!routerHistory) {
        possibleWrappers.push({
            wrapper: WrapWithRouterReduxContainer,
            additionalWrapperArguments: { history: routerHistory },
        });
    }
    generateWrapperComponents(renderData, store).forEach(wrapper => possibleWrappers.push(wrapper));
    return possibleWrappers;
};
export const WrapClientComponent = async (scene, renderData, i18nModule, storeAndRouterHistory) => {
    const dataObject = generateRenderingObject(renderData, i18nModule);
    const possibleWrappers = await getClientWrappers(dataObject, storeAndRouterHistory);
    return WrapComponent(scene, dataObject, possibleWrappers);
};
